<div
  class="mat-drawer-backdrop app-backdrop"
  (click)="closeSidenavMobile()"
  [class.mat-drawer-shown]="isMobileOpen$ | async"
></div>
